// extracted by mini-css-extract-plugin
export default {"wrapper":"faYnMCyxiAYKGF3CIW24","icon":"gcm37ALiWDRKKl1tzDgJ","name":"AJ4BO6XBYiQpvUI4rHpZ"};